<template>
<div>
    <MenuPos/>
    <!-- <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_takeout_admin">
                <img src="@/assets/food-package.png">
            </div>
            <h2 class="title_takeout_admin">ซื้อกลับบ้าน</h2>
        </div>
        <v-btn color="success" height="50" width="20%" @click="$router.push('/poslist')">
            ย้อนกลับ
        </v-btn>
    </div> -->
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <v-row>
                    <v-col cols="12">
                        <div class="text-right mb-3">
                            <v-btn class="link_nametakeoutuser_takeout_admin" height="65" width="20%" @click="pageLink()">                
                                    เพิ่มรายการใหม่
                            </v-btn>
                        </div>
                        <div>
                            <div v-for="(detail,key) in data" :key="key">
                                <div class="pa-3 mt-3 detail_food_yellow_takeout_admin" @click="pageDetail(detail.id)" v-if="detail.status == 0">
                                    <div class="d-flex justify-space-between  align-center">
                                        <div>
                                            <div>{{ detail.customerName }}</div>
                                        </div>
                                        <div class="text-right">
                                            <div class="font_food_yellow_takeout_admin">
                                                กำลังเตรียมอาหาร
                                            </div>
                                            <div>
                                                Total {{ detail.price }} บาท
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pa-3 mt-3 detail_food_green_takeout_admin" v-if="detail.status == 1">
                                    <div class="d-flex justify-space-between  align-center">
                                        <div>
                                            <div>{{ detail.customerName }}</div>
                                        </div>
                                        <div class="text-right">
                                            <div class="font_food_green_takeout_admin">
                                                จ่ายเงินเรียบร้อยแล้ว
                                            </div>
                                            <div>
                                                Total {{ detail.price }} บาท
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pa-3 mt-3 detail_food_red_takeout_admin" v-if="detail.status == 2">
                                    <div class="d-flex justify-space-between  align-center">
                                        <div>
                                            <div>{{ detail.customerName }}</div>
                                            <div class="mb-2 error--text">หมายเหตุ ** {{ detail.description }} **</div>
                                        </div>
                                        <div class="text-right">
                                            <div class="font_food_red_takeout_admin">
                                                ยกเลิกบิล
                                            </div>
                                            <div>
                                                Total {{ detail.price }} บาท
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</div>
</template>

<script>
import MenuPos from '@/components/menuadmin/MenuPos.vue'
// import store from "@/store.js";
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'takeOutAdmin',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    components:{
        MenuPos
    },
    data() {
        return {
            loading_page: true,
            data: [],
        }
    },
    methods: {
        pageLink(){
            this.$router.push(`/nametakeoutuser?store_id=${this.$store.state.userProfile.store_id}`)
        },
        async takeOutList() {
            this.loading_page = true
            HTTP.get('/POS/take-home', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.data = response.data.ordelist
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async pageDetail(id) {
            const idPage = {
                id: id,
            }
            this.$store.commit('detailPaymentTakeOutAdminPage', idPage)
            this.$router.push('/paymenttakeoutadmin')
        }
    },
    mounted() {
        this.takeOutList()
    }
}
</script>
